import React from "react";

import { Box } from "../../core";

export const PanelHeader = (otherProps: any) => (
  <Box p={4} pb={0} {...otherProps} />
);

export default PanelHeader;
